var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.00007L8 9.00007L8 15.7222C8 16.6885 8.34808 17.4778 8.96684 18.0342C9.59329 18.5976 10.5859 19 12 19C13.4141 19 14.4067 18.5976 15.0332 18.0342C15.6519 17.4778 16 16.6885 16 15.7222V11H18V15.7222C18 17.2004 17.4506 18.55 16.3706 19.5213C15.2982 20.4857 13.7908 21 12 21C10.2092 21 8.70175 20.4857 7.62944 19.5213C6.54944 18.55 6 17.2004 6 15.7222L6 9.00007Z",
    fill: "#1A1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.16912C15 6.81352 14.6433 5.53208 13.8727 4.56713C13.0819 3.57698 11.9153 3 10.5 3C9.08467 3 7.91807 3.57698 7.12731 4.56713C6.35667 5.53208 6 6.81352 6 8.16912L6 9.06162L8 9.0625L8 8.16912C8 7.14236 8.27159 6.33924 8.69009 5.81522C9.08846 5.3164 9.67186 5 10.5 5C11.3281 5 11.9115 5.3164 12.3099 5.81522C12.7284 6.33924 13 7.14236 13 8.16912L13 12.9992L15 13V8.16912Z",
    fill: "#1A1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8.00006H11V13.7412C11 14.21 11.1304 14.528 11.2841 14.7104C11.4206 14.8725 11.6328 15 12 15C12.3672 15 12.5794 14.8725 12.7159 14.7104C12.8696 14.528 13 14.21 13 13.7412L13 10.5148L15 10.5143L15 13.7412C15 14.5631 14.7714 15.3746 14.2456 15.9988C13.7026 16.6435 12.9147 17 12 17C11.0853 17 10.2974 16.6435 9.75442 15.9988C9.22858 15.3746 9 14.5631 9 13.7412V8.00006Z",
    fill: "#1A1B1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.aeeed0ef522f29cc4401642b5883ff85.svg";
export { ForwardRef as ReactComponent };